/* ==========================================================================
   Pro Shop Specs & Layout Controller
   ========================================================================== */

import { appState } from './state.js';

export function initProShopSpecs() {
  const papHorizEl = document.getElementById('papHorizVal');
  const papVertEl = document.getElementById('papVertVal');
  const btnEditSpecs = document.getElementById('btnEditSpecs');

  function updateSpecsView() {
    const s = appState.get();
    const specs = s.specs || {};

    if (papHorizEl) papHorizEl.textContent = specs.papHoriz || '5.0" Right';
    if (papVertEl) papVertEl.textContent = specs.papVert || '0.5" Up';
  }

  if (btnEditSpecs) {
    btnEditSpecs.addEventListener('click', () => {
      const newHoriz = prompt('Enter Horizontal PAP (e.g. 5.0" Right):', appState.get().specs.papHoriz);
      if (newHoriz !== null) {
        const newVert = prompt('Enter Vertical PAP (e.g. 0.5" Up):', appState.get().specs.papVert);
        if (newVert !== null) {
          appState.set({
            specs: {
              ...appState.get().specs,
              papHoriz: newHoriz,
              papVert: newVert
            }
          });
          updateSpecsView();
        }
      }
    });
  }

  updateSpecsView();
  appState.subscribe(updateSpecsView);
}
